import React from 'react';
import customAxios from '../../API/customAxios';
import moment from 'moment';

export async function getCompLeaveApproves(getCountOnly = false) {
    const endpoint = getCountOnly ? `/get_comp_leave_reqs?getCountOnly=true` : `/get_comp_leave_reqs`;
    return await customAxios.get(endpoint);
}

export async function getCompLeaveReqApprovalHistory(
    searchFromDate,
    searchToDate
) {
    return await customAxios.get(`/get_comp_leave_req_approval_history`, {
        params: {
            startDate: moment(toNativeDate(searchFromDate)).format('YYYY-MM-DD'),
            endDate: moment(toNativeDate(searchToDate)).format('YYYY-MM-DD')
        },
    });
}

export async function getFullOTHistoryByDate(
    searchFromDate,
    searchToDate
) {
    return await customAxios.get(`/get_full_ot_history_by_date`, {
        params: {
            startDate: moment(toNativeDate(searchFromDate)).format('YYYY-MM-DD'),
            endDate: moment(toNativeDate(searchToDate)).format('YYYY-MM-DD')
        },
    });
}

function toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
}
